import React from "react";
import '../ServicesInfo/servicesInfo.css'


function EmailOutreach(){
    return(
        <div id="email">
            <div className="row w-100 m-0">

                <div className="col-lg-6 p-0 bg-dark">
                    <div className="Col_bg email-outreach"></div>
                </div>

                <div className="col-lg-6 background_lightGrey">
                    <div className="servicesBox_padding">
                        <h1 className="main_heading">02</h1>
                        <div className="bar rounded"></div>
                        <h2 className='main_heading titleFont_style py-2'>Email Outreach & Campaign Management</h2>
                        <p className="text">
                            We design and execute strategic email campaigns that balance personalization with scale while maintaining deliverability and brand reputation.
                        </p>

                        <span className='span_Titles text-dark ' ><b>Campaign types we manage:</b></span>

                        <div className="caseList d-flex flex-wrap py-2">
                            <ul className="all_type_list p-0 pe-5">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Manual email outreach for high-value prospects </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Drip campaigns for nurturing and follow-ups </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Bulk campaigns with controlled targeting</li>
                            </ul>
                            <ul className="all_type_list p-0 ">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Automated campaigns using approved outreach tools </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Data Analysis Service </li>
                            </ul>
                        </div>

                        <span className='span_Titles text-dark ' ><b>Our email services include:</b></span>

                        <div className="caseList d-flex flex-wrap py-2">
                            <ul className="all_type_list p-0 pe-5">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Prospect list building and segmentation </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Message framework and copy optimization </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Deliverability best practices</li>
                            </ul>
                            <ul className="all_type_list p-0 ">
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> Response tracking and qualification </li>
                                <li className=" py-1"><i class="fa-regular fa-circle-dot text_gradient"></i> CRM integration and reporting</li>
                            </ul>
                        </div>

                        <span className='span_Titles text-dark ' ><b>Best for:</b></span>

                        <p className="text">
                            Lead generation, partnership outreach, event promotion, and enterprise prospecting.
                        </p>

                        <a href="/contact" target='_blank' className="btn blue_btn rounded">DISCUSS YOUR PROJECT <i class="fa-solid fa-arrow-right ms-2"></i> </a>
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default EmailOutreach;